import styled from 'styled-components';
import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';

export const ShowBelowDesktop = styled.div`
  display: block;

  @media (min-width: ${BREAKPOINTS.desktop}) {
    display: none;
  }
`;
